import { Api } from './Api';


export function* getSchools(data){
    const jsonData = yield Api.formPost(`/schools/ss`, data);
    return jsonData;
}